export default "__VITE_ASSET__Dpv8BCWP__"